import {IModalOptions} from './modal-options.interface';

export class YesNoModalOptions implements IModalOptions {
  modalClasses = 'modal-info';
  noButtonColour = 'danger';
  noButtonIcon = 'fas fa-times';
  noButtonText = 'No';
  yesButtonColour = 'success';
  yesButtonIcon = 'fas fa-check';
  yesButtonText = 'Yes';
  editButtonIcon: 'fas fa-edit';
}
